import styled from 'styled-components';

export const CellTruncate = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
